import {Base64} from 'js-base64';
import Swal from 'sweetalert2';

/**
 * Método para obtener las acls del usuario.
 *
 * @export
 * @return {*} 
 */
export function getAcls() {
  let permisos = localStorage.getItem('acl');
  if (permisos === null) {
    return {
      roles: [],
      permisos: []
    };
  } else {
    let acl = Base64.decode(permisos);
    acl = JSON.parse(acl);
    acl.permisos = Object.values(acl.permisos);
    return acl;
  }
}

/**
 * Método para obtener el rol asociado al usuario.
 *
 * @export
 */
export function obtenerRol() {
  const acls = getAcls();
  if (acls.roles) {
    return acls.roles.toString();
  } else {
    return '';
  }
}


/**
 * Método para validar los permisos del usuario en las rutas.
 *
 * @export
 * @param {*} permisos
 * @param {*} permiso
 * @return {*} 
 */
export function validarPermiso(permisos, permiso) {
  let autorizado = permiso.filter(function (permi) {
    return permisos.includes(permi);
  });
  if (autorizado.length > 0) {
    return true;
  } else {
    Swal.fire({
      position: 'center',
      icon: 'error',
      title: 'Usted no tiene permisos para ingresar a esta vista',
      showConfirmButton: true,
      timer: 5000
    });
  }
}

/**
 * Método para validar los permisos del usuario dentro de los componentes.
 *
 * @export
 * @param {*} permiso
 */
export function validarPermisoComponente(permiso) {
  const acls = getAcls();
  const permisos = acls.permisos;
  return permisos.some((permi) => permi == permiso);
}

/**
 * Validar el rol asociado al usuario.
 *
 * @export
 * @param {*} rol
 * @return {*} 
 */
 export function validarRol(rol) {
  const acls = getAcls();
  const roles = acls.roles;
  return roles.some((i) => i == rol);
}